import React, { useMemo } from 'react'
import { Text, spacing } from '@retailer-platform/shared-components'
import { Divider } from '@retailer-platform/shared-components/src/tds'
import styled from '@emotion/styled'
import {
  Input,
  PropertyContainer,
  PropertyTitle,
} from '../../../shared-styled-components/SharedStyledComponents'
import { type Mutation } from '../RegexForm'
import { useDomainMessages } from '../../../../utils/domain/intl'
import { RegexCardRulesGrid } from './RegexCardRulesGrid'

interface Props {
  mutation: Mutation
  editting: boolean
  onChange: (mutation: Mutation) => void
  isValid: boolean
  readOnly: boolean
}

const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const RegexCardBody = ({ mutation, editting, onChange, isValid, readOnly }: Props) => {
  const i18n = useDomainMessages({
    noDefault: 'catalogAdminDomain.attributeManagement.regex.form.mutation.noDefault',
  })
  const defaultRule = useMemo(() => mutation.rules.find(r => r.isDefault), [mutation.rules])
  const nonDefaults = useMemo(() => mutation.rules.filter(r => !r.isDefault), [mutation.rules])
  return (
    <div>
      <Text weight="bold">Mutation Details</Text>
      <Row>
        <PropertyContainer style={{ height: spacing.X44, alignItems: 'center' }}>
          <PropertyTitle style={{ marginRight: spacing.X12 }}>Input field:</PropertyTitle>
          {editting ? (
            <Input
              type="text"
              value={mutation.inputField}
              onChange={e => onChange({ ...mutation, inputField: e.target.value })}
              error={!isValid}
            />
          ) : (
            <Text size="small">{mutation.inputField}</Text>
          )}
        </PropertyContainer>
        <PropertyContainer style={{ height: spacing.X44, alignItems: 'center' }}>
          <PropertyTitle style={{ marginRight: spacing.X12 }}>Output field:</PropertyTitle>
          {editting ? (
            <Input
              type="text"
              value={mutation.outputField}
              onChange={e => onChange({ ...mutation, outputField: e.target.value })}
              error={!isValid}
            />
          ) : (
            <Text size="small">{mutation.outputField}</Text>
          )}
        </PropertyContainer>
        <PropertyContainer style={{ height: spacing.X44, alignItems: 'center' }}>
          <PropertyTitle style={{ marginRight: spacing.X12 }}>Default value:</PropertyTitle>
          {editting ? (
            <Input
              type="text"
              value={defaultRule?.replace || ''}
              onChange={e =>
                onChange({
                  ...mutation,
                  rules: [...nonDefaults, { match: '', replace: e.target.value, isDefault: true }],
                })
              }
              error={!isValid}
              placeholder={i18n.noDefault}
            />
          ) : (
            <Text size="small">{defaultRule?.replace || i18n.noDefault}</Text>
          )}
        </PropertyContainer>
      </Row>
      <Divider />
      <Text weight="bold">Rules</Text>
      <RegexCardRulesGrid
        rules={nonDefaults}
        onChange={rules =>
          onChange({ ...mutation, rules: defaultRule ? [defaultRule, ...rules] : rules })
        }
        readOnly={readOnly}
      />
    </div>
  )
}
